export default __webpack_public_path__ + "static/media/Draw TexturedTexturized Yarn .8854c3a6.jpg";